import {STATUSES} from "../pharmacyTypeDefs";
import {useQuery} from "@apollo/client";

export const useQueryStatuses = (options?: any): any => (
  useQuery(STATUSES, options)
);
